import { useEffect, useRef, useState } from "react";
import { RotateCcw, Send } from "lucide-react";
import api from "@/lib/api";
import { adminAgent, agentError, newId } from "@/lib/agent";
import { AgentButton, Field, Notice, Empty } from "@/components/agent/AgentUI";
import { MessageList } from "@/components/agent/MessageList";
import { FichaPanel } from "@/components/agent/FichaPanel";

// Mismo motor que WhatsApp, sin Twilio: el equipo prueba la conversación antes de abrirla al público.
export default function Sandbox() {
  const [session, setSession] = useState(null);
  const [text, setText] = useState("");
  const [pending, setPending] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  // Un reintento del mismo texto reutiliza su identificador: el backend no duplica el mensaje.
  const [retry, setRetry] = useState(null);
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [session, pending]);

  const start = async () => {
    setBusy(true); setError("");
    try { const { data } = await api.post(adminAgent + "/sandbox", {}); setSession(data); setText(""); setRetry(null); }
    catch (e) { setError(agentError(e)); } finally { setBusy(false); }
  };
  const send = async e => {
    e.preventDefault();
    const value = text.trim();
    if (!value || busy || !session) return;
    const requestId = retry?.text === value ? retry.id : newId();
    setBusy(true); setError(""); setPending(value); setText("");
    try { const { data } = await api.post(`${adminAgent}/sandbox/${session.id}/messages`, { text: value, request_id: requestId }); setSession(data); setRetry(null); }
    catch (ex) {
      setError(agentError(ex)); setText(value); setRetry({ text: value, id: requestId });
      try { const { data } = await api.get(`${adminAgent}/sandbox/${session.id}`); setSession(data); } catch { /* conserva la vista actual */ }
    } finally { setBusy(false); setPending(""); }
  };
  const shown = session ? [...session.messages, ...(pending ? [{ id: "pending-user", role: "user", text: pending }] : [])] : [];

  return <div data-testid="agent-sandbox-page">
    <div className="ag-section-heading"><div><h2>Probar el agente</h2><p>Conversa con el mismo agente que atiende WhatsApp. Las propuestas que registres aquí quedan marcadas como «prueba» y no salen en el CSV.</p></div>
      <div className="ag-actions">
        <AgentButton secondary onClick={start} disabled={busy} data-testid="sandbox-start"><RotateCcw size={16} />{session ? "Nueva conversación" : "Iniciar conversación"}</AgentButton></div></div>
    <Notice error id="sandbox-error">{error}</Notice>
    <div className="ag-inbox ag-sandbox">
      <section className="ag-transcript">{!session ? <Empty id="sandbox-empty">Inicia una conversación de prueba. Escribe como lo haría un empresario por WhatsApp.</Empty> : <>
        <div className="ag-transcript-scroll"><MessageList messages={shown} pending={!!pending} /><div ref={end} /></div>
        <form className="ag-admin-reply" onSubmit={send}><Field label="Mensaje del participante (simulado)" id="sandbox-message"><textarea id="sandbox-message" data-testid="sandbox-message" rows={3} maxLength={4000} value={text} onChange={e => setText(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) send(e); }} disabled={busy} /></Field>
          <AgentButton type="submit" disabled={busy || !text.trim()} data-testid="sandbox-send"><Send size={16} />{busy ? "Respondiendo…" : "Enviar"}</AgentButton></form></>}
      </section>
      <aside className="ag-sandbox-ficha"><FichaPanel ficha={session?.ficha} folios={session?.registered_folios} /></aside>
    </div>
  </div>;
}
